$exso_sheets_plans_class $exso_sheets
	paths / \/api/plans
	order_by / \date
	columns *
		blast *
			title @ \Объем взорванной массы
			unit @ \м³
		burnt *
			title @ \Обурено
			unit @ \п.м.
